import { useSelector } from "react-redux";
import {
  createSearchParams,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { renderCategoryRoute } from "../Function";

export const useAccessLink = (
  single = false,
  data = {},
  filterDelete = () => {}
) => {
  const { slug, city_slug } = useParams();
  const { cities } = useSelector(state => state);
  const [searchParams, setSearchParams] = useSearchParams();
  const search = {
    tag: searchParams.get("tag"),
    item_gender: searchParams.get("item_gender"),
    city_id: searchParams.get("city_id"),
    title: searchParams.get("title"),
    category_id: searchParams.get("category_id"),
    sort: searchParams.get("sort"),
    page: searchParams.get("page") || 1,
    name: searchParams.get("name"),
  };
  const location = useLocation();
  const categoryPath = location.pathname.split("/")[1];
  const navigate = useNavigate();

  const getValue = key => {
    if (key) {
      return search[key];
    }
    return false;
  };
  const renderCategoryName = id => {
    switch (+id) {
      case 1:
        return "استخر و مجموعه های آبی";
      case 2:
        return "سالن ورزشی";

      case 3:
        return "باشگاه بدنسازی";

      default:
        break;
    }
  };
  const elements = [
    {
      type: "site",
    },
    {
      type: "category",
    },
    {
      type: "city",
    },
    {
      type: "itemName",
    },
  ];
  const renderLinkName = link => {
    switch (link.type) {
      case "site":
        return "نیکوتن";
      case "category":
        if (single && data) {
          return data.category && data.category.name;
        } else if (categoryPath) {
          return renderCategoryRoute(categoryPath)["name"];
        }
        return "مجموعه های ورزشی";

      case "city":
        if (single && data) {
          return data.city && data.city[0] && data.city[0].name;
        } else {
          return (
            cities &&
            cities
              .map(city => {
                if (city.slug == city_slug) {
                  return city;
                }
              })
              .filter(Boolean)[0].name
          );
        }
        return "";
      case "itemName":
        if (slug) {
          return slug;
        }
        break;
      default:
        break;
    }
  };
  const renderCount = () => {
    let count = 0;
    elements.map(link => {
      if (renderLinkName(link)) {
        count++;
      }
    });
    return count;
  };

  const linkHandler = type => {
    switch (type) {
      case "site":
        navigate("/");
        break;
      case "category":
        if (single) {
          navigate(
            renderCategoryRoute(data.category && data.category.id)["route"]
          );
        } else {
          filterDelete("city_id");
        }
        break;
      case "city":
        if (single) {
          navigate(
            `${
              renderCategoryRoute(data.category && data.category.id)["route"]
            }/${data.city && data.city[0] && data.city[0].slug}`
          );
        } else {
          filterDelete("city_id");
        }
        break;
      default:
        break;
    }
  };
  return {
    location,
    getValue,
    renderCategoryName,
    navigate,
    elements,
    renderLinkName,
    renderCount,
    linkHandler,
  };
};
